export default {"src":"/_next/static/media/linkedin-social.ad0cec8f.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};